import { render } from "./MStickerSheet.vue?vue&type=template&id=8de0dbd6&scoped=true&ts=true"
import script from "./MStickerSheet.vue?vue&type=script&lang=ts"
export * from "./MStickerSheet.vue?vue&type=script&lang=ts"

import "./MStickerSheet.vue?vue&type=style&index=0&id=8de0dbd6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/mingaku/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8de0dbd6"]])

export default __exports__